import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { trendTooltip } from '../utils/rarity';

interface RarityStarsProps {
  stars: number | null; // null = not rated
  tooltip?: string;
  provisional?: boolean;
  trend?: 'up' | 'down' | null;
  trendSince?: string | null;
  size?: 'sm' | 'md';
}

const RarityStars: React.FC<RarityStarsProps> = ({
  stars,
  tooltip,
  provisional = false,
  trend = null,
  trendSince = null,
  size = 'md',
}) => {
  const fontSize = size === 'sm' ? '0.8rem' : '1.1rem';

  const starsInner =
    stars == null ? (
      <Box component="span" sx={{ color: 'text.disabled', fontSize, lineHeight: 1, cursor: tooltip ? 'help' : 'default' }}>
        —
      </Box>
    ) : (
      <Box sx={{ display: 'flex', gap: size === 'sm' ? '1px' : '2px', cursor: tooltip ? 'help' : 'default' }}>
        {[1, 2, 3, 4, 5].map((i) => (
          <Box
            key={i}
            component="span"
            sx={{
              color: i <= stars
                ? (provisional ? 'rgba(255,215,0,0.45)' : '#FFD700')
                : 'rgba(255,255,255,0.15)',
              fontSize,
              lineHeight: 1,
            }}
          >
            ★
          </Box>
        ))}
      </Box>
    );

  const starsBlock = tooltip ? (
    <Tooltip title={tooltip} arrow placement="top">
      <span>{starsInner}</span>
    </Tooltip>
  ) : (
    starsInner
  );

  if (!trend) return starsBlock;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {starsBlock}
      <Tooltip title={trendTooltip(trend, trendSince, stars)} arrow placement="top">
        <Box
          component="span"
          sx={{
            // Arrow points in the direction of RARITY: a show drying up
            // (trend 'down') is getting rarer → orange up; a show appearing
            // more often (trend 'up') is getting less rare → green down.
            color: trend === 'up' ? '#66bb6a' : '#ffa726',
            fontSize,
            fontWeight: 700,
            lineHeight: 1,
            cursor: 'help',
          }}
        >
          {trend === 'up' ? '▼' : '▲'}
        </Box>
      </Tooltip>
    </Box>
  );
};

export default RarityStars;
